var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.75 17.5L12.7501 12.5M14.4167 8.33333C14.4167 11.555 11.805 14.1667 8.58333 14.1667C5.36167 14.1667 2.75 11.555 2.75 8.33333C2.75 5.11167 5.36167 2.5 8.58333 2.5C11.805 2.5 14.4167 5.11167 14.4167 8.33333Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Search.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Search;

Search.default = Search;
